const draggableTypes = {
	HTAB: 'HTAB',
	VTAB: 'VTAB',
	VCONTAINER: 'VCONTAINER',
	HCARD: 'HCARD',
};

export default draggableTypes;
